export const permissionsKeys = {
  page: 'content-management',
} as const;
